<div class="table-responsive">
  <table class="table table-striped table-hover" style="font-size: 14px">
    <thead style="color:#1b6d85">
      <tr>
        <th scope="col"></th>
        <th scope="col">Date</th>
        <th scope="col">Response</th>
        <th scope="col">ITz</th>
        <th scope="col">Creator</th>
        <th scope="col" style="width:10%">Title</th>
        <th scope="col" style="width:40%">Purpose</th>
        <th scope="col">Participation</th>
        @if (isAdmin()) {
          <th scope="col">Present</th>
        }
        @if (isAdmin()) {
          <th scope="col">Refused</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (item of scheduledEvents; track item) {
        <tr [ngClass]='{"success": item.highlighted}' >
          <td><img [src]="getIcon(item.eventType)" [title]="item.eventType" border=3 height=24 width=24/></td>
          <td>{{item.possibleDate}}</td>
          <td>{{item.status}}</td>
          <td>{{item.itzName}}</td>
          <td>{{item.creationUser}}</td>
          <td>{{item.label}}</td>
          <td [innerHTML]="item.purpose"></td>
          <td>{{item.participation}}</td>
          @if (isAdmin()) {
            <td>{{item.valitatedCount}}</td>
          }
          @if (isAdmin()) {
            <td>{{item.refusedCount}}</td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="row position-absolute bottom-0 end-0">
  <button class="btn btn-raised" (click)="goBack()">RETURN</button>
</div>
